import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';
import { getRoleListV1, getRoleDetail, getRoleMenus, saveRole, adminRoles } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';


class adminAddRole extends Component {

    constructor(props) {
        super(props);
        var url = new URL(window.location.href);
        var location = url.searchParams.get("location");
        var auth_data = JSON.parse(localStorage.getItem("user_data"));
        this.state = {
              logged: localStorage.getItem("authentication"),
              auth_data: JSON.parse(localStorage.getItem("user_data")),
              location: location ? location : (auth_data.access_location ? auth_data.access_location : 'Bengaluru'),
              menu_list: [],
              role_id:0,
              new_read_access: [1],
              new_write_access: [1],
              new_download_access: [1]
        };

        this.id = this.props.match.params.id ? this.props.match.params.id : '';

        if(this.id!='')
          this.getRoleDetail();

        this.getMenu();

    }


    componentDidMount() {

    }


    getRoleDetail = async () => {
      let req = JSON.stringify({
        id: this.id
      });
      getRoleDetail(req).then(res => {
        if (res.status === 1) {
          this.setState({
            role: res.data.role,
            role_id:res.data.id,
            new_read_access: res.data.new_read_access,
            new_write_access: res.data.new_write_access,
            new_download_access: res.data.new_download_access
          })
        }
      })
    }    


    getMenu = async () => {
      let req = JSON.stringify({
        role: 1,
        url: 'getMenu'
      });
      getRoleMenus(req).then(res => {
        if (res.status === 1) {
          this.setState({
            menu_list: res.results
          })
        }
      })
    } 

  handleChange = (e) => {
    const propName = e.target.name;
    const propValue = e.target.value;
    if (propName == 'role_name')
      this.checkName(propValue);
    this.setState({
      [propName]: propValue
    })
  }

 checkName = (val) => {
    let req = JSON.stringify({
      value: val,
      role_id: this.state.role_id,
      role: 1,
      url: 'checkName'
    });
    adminRoles(req).then(res => {
      if (res.status === 1) {
        this.setState({
          isNameValid: res.avail
        })
      }
    });
  }



  submitForm = (e) => {

  
      let req = JSON.stringify({
        role_name: this.state.role_name,
        role_id: this.state.role_id,
        read_access: this.state.new_read_access,
        write_access: this.state.new_write_access,
        download_access: this.state.new_download_access,
      });

      console.log(req);

      saveRole(req).then(res => {
        let toastr = '';
        if (res.status === 1) {
           alert("Successfully updated");
           this.setState({openAdd:false});
            
           this.getList(); 
        } else {

           alert("error");
        }
      });
   
  }

  customeChangeCheckBox = (e, i, id) => {
    const propName = e.target.name;
    
    const propValue = id;
    var propData = this.state[propName];

    if (propData.includes(propValue)) {
      const id = propData.indexOf(propValue); // 2
      propData.splice(id, 1);
    } else {
      propData.push(propValue);
    }
    console.log('propData', propData)
    this.setState({
      [propName]: propData
    })
  }

    render() {

        const {  menu_list, new_read_access, new_write_access, new_download_access, role_id } = this.state;

        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Roles</h4>


            
                  <div  class="row">
                  <div class="col-lg-12">
                  
                        <div className="box-shadow-custom">
                          <div className="row">

                            <div className="form-group col-md-4">
                              <label className="text-capitalize">Role Name<span className="astrick">*</span></label>
                              <input type='text' className='form-control' onChange={this.handleChange} name='role_name' value={this.state.role} />
                               
                            </div>
                          </div>
                          <div className="row">
                            <div className="form-group col-md-12">
                              <table className='table table-bordered'>
                                <thead>
                                  <tr>
                                    <th>Menu</th>
                                    <th>Read Access</th>
                                    <th>Write Access</th>
                                    <th>Download Access</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {menu_list.map((item, i) => {
                                    let subList = menu_list.filter((data => data.parent_id == item.id));
                                    if (item.parent_id == 0) {
                                      let checkedR = new_read_access.includes(item.id) ? true : false;
                                      let checkedW = new_write_access.includes(item.id) ? true : false;
                                      let checkedD = new_download_access.includes(item.id) ? true : false;
                                      

                                      return (
                                        <React.Fragment>
                                          <tr>
                                            <td><b>{item.menu_name}</b></td>
                                            <td><input className='form-control checkbox-cus' defaultChecked={checkedR} checked={checkedR} 
                                              type='checkbox' name='new_read_access' value={item.id} onChange={(e) => this.customeChangeCheckBox(e, i, item.id)} /></td>
                                           
                                           {item.is_parent==0 && 
                                            <td><input className='form-control checkbox-cus' defaultChecked={checkedW}  checked={checkedW}
                                              type='checkbox' name='new_write_access' value={item.id} onChange={(e) => this.customeChangeCheckBox(e, i, item.id)} /></td>
                                            }
                                            {item.is_parent==0 && 
                                            <td><input className='form-control checkbox-cus' defaultChecked={checkedD}  checked={checkedW}
                                              type='checkbox' name='new_download_access' value={item.id} onChange={(e) => this.customeChangeCheckBox(e, i, item.id)} /></td>
                                            }
                                           
                                          </tr>
                                          {subList.map((sitem, j) => {
                                            let checkedRs = i === 0 ? true : (new_read_access.includes(sitem.id)) ? true : false;
                                            let checkedWs = i === 0 ? true : (new_write_access.includes(sitem.id)) ? true : false;
                                            let checkedDs = i === 0 ? true : (new_download_access.includes(sitem.id)) ? true : false;
                                            let disabled = sitem.menu_name === 'Role' ? true : false;
                                            return (
                                              <tr>
                                                <td> ------- {sitem.menu_name}</td>
                                                <td><input className='form-control checkbox-cus' defaultChecked={checkedRs} checked={checkedRs} 
                                                  type='checkbox' name='new_read_access' value={item.id} onChange={(e) => this.customeChangeCheckBox(e, j, sitem.id)} /></td>
                                                <td><input className='form-control checkbox-cus' defaultChecked={checkedWs} checked={checkedWs} 
                                                  type='checkbox' name='new_write_access' value={item.id} onChange={(e) => this.customeChangeCheckBox(e, j, sitem.id)} /></td>
                                                <td><input className='form-control checkbox-cus' defaultChecked={checkedDs} checked={checkedDs} 
                                                  type='checkbox' name='new_download_access' value={item.id} onChange={(e) => this.customeChangeCheckBox(e, j, sitem.id)} /></td>
                                              </tr>
                                            )
                                          })}
                                        </React.Fragment>
                                      )
                                    }
                                  })}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-12 col-xs-12 btn-bdr">
                          <button id="btnSubmit" className="btn btn-primary btn-sm" onClick={this.submitForm}>Submit</button> &nbsp; <a href="/admin/roles" className="btn btn-primary btn-sm">List</a>
                        </div>
                      
                       </div>
                  </div>

               
                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default adminAddRole;


// WEBPACK FOOTER //
// ./src/components/bewise/adminAddRole.jsx